import Panel from '../components/panel'
import {Button} from '../components/button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";

import ModalConfirmButton from '../components/modal_close_button.tsx';

export default function ModalLueftung() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
  return (<Panel >
            <h1 id="modal-title">Welche Lüftungsanlage wird genutzt?</h1>
            <PropertyInput type="lueftung"/>
            <PropertyInput type="lueftung_datum"/>
            
           <ModalConfirmButton  onClick={()=>{
                close_menu();
                init_property_if_undefined("lueftung");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}

